export const inquiryChannelChartOption = (
  seriesData = [],
  year = new Date().getFullYear()
) => {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const categories = months.map((month) => `${month}/${String(year).slice(2)}`);

  return {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "20%",
        horizontal: false,
      },
    },
    colors: [
      "#283c50",
      "#3454d1",
      "#fb8500",
      "#25b865",
      "#ffb703",
      "#00b4d8",
      "#ff006e",
      "#8338ec",
      "#3a0ca3",
      "#fb5607",
      "#ffbe0b",
      "#6a4c93",
      "#007f5f",
      "#d62828",
      "#2ec4b6",
    ],
    series: seriesData,
    xaxis: {
      categories: categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: {
          fontSize: "10px",
          colors: "#64748b",
        },
      },
    },
    yaxis: {
      min: 0,
      tickAmount: 5,
      labels: {
        formatter: (value) => {
          if (value >= 1000) return `${value / 1000} K`;
          return value;
        },
      },
    },
    grid: {
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: false } },
      padding: { left: 20, right: -10 },
    },
    dataLabels: { enabled: false },
    tooltip: {
      intersect: false,
      shared: true,
      inverseOrder: true,
      y: {
        formatter: (value) => `${value}`,
      },
      style: {
        fontSize: "11px",
        fontFamily: "Inter",
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "left",
      fontSize: "12px",
      fontFamily: "Inter",
      labels: {
        fontSize: "12px",
        colors: "#64748b",
      },
      markers: {
        shape: "circle",
      },
      itemMargin: {
        horizontal: 5,
        vertical: 15,
      },
    },
  };
};
